/* global menu */
(() => {
    let sourceTree = null;

    function readTree() {
        if (sourceTree !== null) return sourceTree;
        let supplied;
        try {
            if (typeof menu === 'undefined' || !Array.isArray(menu)) return null;
            supplied = menu;
        } catch {
            return null;
        }
        let remaining = 10000;
        const seen = new WeakSet();
        const visit = (items, depth) => {
            if (!Array.isArray(items) || depth > 8) return [];
            const result = [];
            for (const item of items) {
                if (remaining-- <= 0) break;
                if (!item || typeof item !== 'object' || seen.has(item)) continue;
                seen.add(item);
                if (typeof item.name !== 'string' || !item.name.trim() || item.name.length > 512 ||
                    typeof item.link !== 'string' || item.link.length > 255 || !/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(item.link)) continue;
                result.push({name: item.name, link: item.link, children: visit(item.children, depth + 1)});
            }
            return result;
        };
        sourceTree = visit(supplied, 1);
        return sourceTree;
    }

    function findPath(node, handle) {
        if (node.link === handle) return [node];
        for (const child of node.children) {
            const path = findPath(child, handle);
            if (path) return [node, ...path];
        }
        return null;
    }

    function collectionPrefix(target) {
        try {
            const url = new URL(target.dataset.sbCollectionPrefix, window.location.origin);
            if (url.origin === window.location.origin && !url.username && !url.password &&
                !url.search && !url.hash && /\/collections\/$/.test(url.pathname)) return url.pathname;
        } catch { /* Keep the native fallback if its destination cannot be verified. */
        }
        return null;
    }

    function itemElement(node, prefix, current) {
        const item = document.createElement('li');
        item.className = 'sb-category-item';
        const link = document.createElement('a');
        link.className = 'sb-category-link';
        link.href = prefix + node.link;
        if (node.link === current) {
            item.classList.add('sb-category-item--active');
            link.setAttribute('aria-current', 'page');
        }
        const title = document.createElement('span');
        title.className = 'sb-category-link__title';
        title.textContent = node.name;
        link.append(title);
        item.append(link);
        return item;
    }

    function listElement(nodes, prefix, current) {
        const list = document.createElement('ul');
        list.className = 'sb-category-list';
        nodes.forEach((node) => list.append(itemElement(node, prefix, current)));
        return list;
    }

    function render() {
        const tree = readTree();
        const all = tree?.find((node) => node.link === 'all');
        if (!all) return;
        document.querySelectorAll('ul[data-sb-book-menu], ul[data-sb-kids-menu]').forEach((target) => {
            if (target.dataset.sbMenuReady === 'true') return;
            const prefix = collectionPrefix(target);
            const branch = target.hasAttribute('data-sb-book-menu') ? all : findPath(all, target.dataset.sbKidsMenu)?.at(-1);
            const children = target.hasAttribute('data-sb-book-menu') ? branch?.children : branch?.children.slice(0, 12);
            if (!prefix || !children?.length) return;
            target.replaceChildren(...children.map((node) => itemElement(node, prefix)));
            target.dataset.sbMenuReady = 'true';
        });
        document.querySelectorAll('nav[data-sb-generated-categories]').forEach((target) => {
            if (target.dataset.sbMenuReady === 'true') return;
            const content = target.querySelector('[data-sb-category-content]');
            const prefix = collectionPrefix(target);
            if (!content || !prefix) return;
            const current = target.dataset.sbCollectionHandle || 'all';
            const matched = findPath(all, current);
            const trail = matched || [all];
            const list = listElement(trail, prefix, current);
            const children = matched?.at(-1).children;
            if (children?.length) {
                const nested = listElement(children, prefix, current);
                nested.classList.add('sb-category-list--nested');
                list.lastElementChild.append(nested);
            }
            content.replaceChildren(list);
            target.dataset.sbMenuReady = 'true';
        });
        if (document.querySelector('nav[data-sb-generated-categories][data-sb-menu-ready="true"]')) {
            const legacy = document.getElementById('myUL')?.parentElement;
            if (legacy?.matches('.shopify-section.announcement-bar-section')) legacy.hidden = true;
        }
    }

    function start() {
        render();
        // Bookarb's existing async ScriptTag may finish after DOMContentLoaded.
        const listenToSource = (script) => {
            let url;
            try {
                url = new URL(script.src, window.location.href);
            } catch {
                return false;
            }
            if (url.hostname === 'd1r9o33kk12489.cloudfront.net' && url.pathname === '/menu.js') {
                script.addEventListener('load', render, {once: true});
                return true;
            }
            return false;
        };
        let sourceFound = false;
        document.querySelectorAll('script[src]').forEach((script) => {
            if (listenToSource(script)) sourceFound = true;
        });
        if (!sourceFound && sourceTree === null && document.head) {
            // Shopify can insert the existing ScriptTag from its window.load handler.
            const sourceObserver = new MutationObserver((changes) => {
                for (const change of changes) {
                    for (const node of change.addedNodes) {
                        if (node.nodeType === Node.ELEMENT_NODE && node.matches('script[src]') && listenToSource(node)) {
                            sourceObserver.disconnect();
                            return;
                        }
                    }
                }
            });
            sourceObserver.observe(document.head, {childList: true});
        }
        const grid = document.getElementById('ProductGridContainer');
        if (grid) {
            // Shopify's collection filters replace this container's children without an event.
            new MutationObserver((changes) => {
                const addedNavigation = changes.some((change) => Array.from(change.addedNodes).some((node) =>
                    node.nodeType === Node.ELEMENT_NODE && (node.matches('nav[data-sb-generated-categories]') ||
                        node.querySelector('nav[data-sb-generated-categories]'))));
                if (addedNavigation) render();
            }).observe(grid, {childList: true, subtree: true});
        }
    }

    window.addEventListener('load', render, {once: true});
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
    else start();
})();
